import { LANGUAGES, QUESTION_TYPES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const SORT_BY_CODE = 'sort by code'
export const CHANGE_QUESTION_BELOW = 'Change question below'

export const COPY_QUESTION = 'Copy question'
export const COPY_QUESTION_IN_DIFF_GROUPS = 'Copy question in diff groups'

export const MOVE_UP = 'move up'
export const MOVE_TO_START = 'Move to the start'
export const MOVE_DOWN = 'Move down'
export const MOVE_TO_END = 'Move to the end'
export const ADD_UP = 'add up'
export const ADD_DOWN = 'add down'

export const COPY_GROUP = 'COPY_GROUP_DOWN'

export const DELETE = 'delete'

export const ENTER_QUESTION_CODE = 'Enter the question code'

export const LABEL_ADD_SUB_QUESTIONS = 'label add sub questions'
export const LABEL_ADD_ANSWER = 'label add answer'

export const VALIDATION_SLIDER_QUESTION = 'validation slider question'

export const ADD_QUESTION = 'add question'

export const DELETE_MODAL_MESSAGE = 'delete modal message'

export const MODAL_TEXT_DELETE = 'modal text delete'
export const MODAL_TEXT_DELETE_WITH_LOGIC = 'modal text delete with logic'
export const MODAL_TEXT_DELETE_WITH_RELATED_LOGIC =
  'modal text Deleting questions with logic'
export const MODAL_DELETE_CONDITION_ERASED = 'delete modal condition erased'
export const MODAL_TEXT_NOT_DELETE = 'modal text not delete'
export const MODAL_ARE_YOU_SURE = 'modal are you sure'

export const FORMULA_ADVICE = 'formula-advice'

export const ALTERNATIVES_ADVICE = 'alternatives-advice'

export const CHANGE_BELOW_MESSAGE = 'change below message'
export const QUESTION_CODE_ERROR = 'question code error'

export const VALIDATION_LOGICS_AND_CONDITIONS = 'validation logics and conditions'

export const VALIDATION_CHANGE_QUESTION_CODE = 'validation change question code'

export default {
  [PORTUGUESE]: {
    [SORT_BY_CODE]: 'Ordenar por código',
    [CHANGE_QUESTION_BELOW]: 'Alterar perguntas embaixo',

    [COPY_QUESTION]: 'Copiar pergunta',
    [COPY_QUESTION_IN_DIFF_GROUPS]: 'Copiar pergunta de grupos diferentes',

    [MOVE_UP]: 'Mover para cima',
    [MOVE_TO_START]: 'Mover para o início',
    [MOVE_DOWN]: 'Mover para baixo',
    [MOVE_TO_END]: 'Mover para o fim',

    [ADD_UP]: 'Adicionar em cima',
    [ADD_DOWN]: 'Adicionar embaixo',

    [COPY_GROUP]: 'Copiar grupo',

    [DELETE]: 'Deletar',

    [ENTER_QUESTION_CODE]: 'Digite o código da pergunta',

    [LABEL_ADD_SUB_QUESTIONS]: 'Adicione pelo menos uma subpergunta para continuar',
    [LABEL_ADD_ANSWER]: 'Adicione pelo menos uma resposta para continuar.',

    [VALIDATION_SLIDER_QUESTION]:
      'Configurações avançadas necessárias para o tipo de controle deslizante: Inicial/Min. Valor, Final/Máx. Precisão de valor e controle deslizante',

    [ADD_QUESTION]: 'Adicionar pergunta',

    [QUESTION_TYPES.radio]: 'Escolha Única',
    [QUESTION_TYPES.message]: 'Mensagem',
    [QUESTION_TYPES.checkbox]: 'Múltipla Escolha',
    [QUESTION_TYPES.text]: 'Texto Livre',
    [QUESTION_TYPES.multiText]: 'Texto Livre Múltiplo',
    [QUESTION_TYPES.number]: 'Entrada Numérica',
    [QUESTION_TYPES.multiNumber]: 'Entrada Numérica Múltipla',
    [QUESTION_TYPES.slider]: 'Slider',
    [QUESTION_TYPES.matrixRadio]: 'Matriz',
    [QUESTION_TYPES.matrixCheckbox]: 'Matriz de Múltipla Escolha',
    [QUESTION_TYPES.ranking]: 'Ranking',
    [QUESTION_TYPES.mesage]: 'Mensagem de Texto',
    [QUESTION_TYPES.dragAndDrop]: 'Drag and Drop',
    [QUESTION_TYPES.formula]: 'Fórmula',

    [DELETE_MODAL_MESSAGE]: (name, questionsText) =>
      `Tem certeza de que deseja excluir o grupo ${name}? ${
        questionsText ? 'Existem algumas perguntas embutidas nele.' : ''
      }`,

    [MODAL_TEXT_DELETE]: code => `Tem certeza de que deseja excluir ${code}?`,

    [MODAL_TEXT_DELETE_WITH_LOGIC]: code =>
      `Ao excluir esta pergunta, você estará removendo todas as lógicas e fluxos relacionados a ela. Recomendamos revisar o questionário após aplicar essa alteração. Tem certeza de que deseja excluir ${code}?`,

    [MODAL_TEXT_DELETE_WITH_RELATED_LOGIC]: code =>
      `Esta pergunta está sendo exibida na condição da(s) pergunta(s) ${code}. Se você excluí-lo, <strong>essa condição será apagada</strong>. Você tem certeza que quer continuar?`,

    [MODAL_TEXT_NOT_DELETE]: code =>
      `Se você continuar com essa alteração, uma ou mais condições serão invalidadas. Por favor, verifique a(s) pergunta(s) ${code}. Você tem certeza que quer continuar?`,

    [MODAL_ARE_YOU_SURE]: 'Você tem certeza que quer continuar?',

    [FORMULA_ADVICE]: formulaCode =>
      `Esta questão está sendo referenciada em uma fórmula de ${formulaCode}. Alterar esse tipo de questão pode quebrar ou apagar sua lógica. `,

    [ALTERNATIVES_ADVICE]: references =>
      `Se você continuar com essa mudança, suas ${references} será apagado. `,

    [CHANGE_BELOW_MESSAGE]:
      'O código deve ser letras/números ou qualquer/!número!/qualquer.',

    [QUESTION_CODE_ERROR]:
      'O código da questão não pode começar com número e não pode ser somente números.',

    [VALIDATION_LOGICS_AND_CONDITIONS]: `O fluxo e as lógicas do questionário foram criados utilizando os códigos de pergunta atuais.
    Se você alterá-los agora, <strong>todas as condições serão excluídas</strong> e você terá que adicioná-las novamente.
    Você tem certeza que quer continuar?`,

    [VALIDATION_CHANGE_QUESTION_CODE]:
      'Se você alterar o código da pergunta, toda a lógica que fizer referência a essa pergunta será excluída.',
  },

  [ENGLISH]: {
    [SORT_BY_CODE]: 'Sort By Code',
    [CHANGE_QUESTION_BELOW]: 'Change questions below',

    [COPY_QUESTION]: 'Copy question',
    [COPY_QUESTION_IN_DIFF_GROUPS]: 'Copy question in diff groups',

    [MOVE_UP]: 'Move up',
    [MOVE_TO_START]: 'Move to the start',
    [MOVE_DOWN]: 'Move down',
    [MOVE_TO_END]: 'Move to the end',

    [ADD_UP]: 'Add up',
    [ADD_DOWN]: 'Add down',

    [COPY_GROUP]: 'Copy group',

    [DELETE]: 'Delete',

    [ENTER_QUESTION_CODE]: 'Enter the question code',

    [LABEL_ADD_SUB_QUESTIONS]: 'Please add at least one sub question to proceed.',
    [LABEL_ADD_ANSWER]: 'Please add at least one answer to proceed.',

    [VALIDATION_SLIDER_QUESTION]:
      'Advanced settings required for slider type: Starting/Min. Value, Ending/Max. Value and Slider Accuracy',

    [ADD_QUESTION]: 'Add Question',

    [QUESTION_TYPES.radio]: 'Single Choice',
    [QUESTION_TYPES.message]: 'Message',
    [QUESTION_TYPES.checkbox]: 'Multiple Choice',
    [QUESTION_TYPES.text]: 'Free Text',
    [QUESTION_TYPES.multiText]: 'Multiple Free Text',
    [QUESTION_TYPES.number]: 'Numerical Input',
    [QUESTION_TYPES.multiNumber]: 'Multiple Numerical Input',
    [QUESTION_TYPES.slider]: 'Slider',
    [QUESTION_TYPES.matrixRadio]: 'Matrix',
    [QUESTION_TYPES.matrixCheckbox]: 'Matrix Multiple Choice',
    [QUESTION_TYPES.ranking]: 'Ranking',
    [QUESTION_TYPES.mesage]: 'Text Message',
    [QUESTION_TYPES.dragAndDrop]: 'Drag and Drop',
    [QUESTION_TYPES.formula]: 'Formula',

    [DELETE_MODAL_MESSAGE]: (name, questionsText) =>
      `Are you sure you want to delete the ${name} group? ${
        questionsText ? 'There are some questions built into it.' : ''
      }`,

    [MODAL_TEXT_DELETE]: code => `Are you sure you want to delete ${code}?`,

    [MODAL_TEXT_DELETE_WITH_LOGIC]: code =>
      `By deleting this question, you will be removing all logics and flows related to it. We recommend reviewing the questionnaire after applying this change. Are you sure you want to delete ${code}?`,

    [MODAL_TEXT_DELETE_WITH_RELATED_LOGIC]: code =>
      `This question is being displayed in the condition of question(s) ${code}. If you delete it, <strong>this condition will be erased</strong>. Are you sure you want to continue?`,

    [MODAL_TEXT_NOT_DELETE]: code =>
      `If you continue with this change, one or more conditions will be invalidated. Please check question(s) ${code} Are you sure you want to continue?`,

    [MODAL_ARE_YOU_SURE]: 'Are you sure you want to continue?',

    [FORMULA_ADVICE]: formulaCode =>
      `This question is being referenced in a formula from ${formulaCode}. Changing this type of question can break or erase your logic. `,

    [ALTERNATIVES_ADVICE]: references =>
      `If you continue with this change, your ${references} will be erased. `,

    [CHANGE_BELOW_MESSAGE]: 'Code must be letters/numbers or any/!number!/any.',

    [QUESTION_CODE_ERROR]:
      'The question code cannot start with a number and cannot be just numbers.',

    [VALIDATION_LOGICS_AND_CONDITIONS]: `Flow logic and conditions have been created with the current question codes.
    If you change them now, <strong>all conditions will be deleted</strong> and you will have to add them again.
    Are you sure you want to continue?`,

    [VALIDATION_CHANGE_QUESTION_CODE]:
      'If you change the question code, all logic that references that question will be deleted.',
  },

  [SPANISH]: {
    [SORT_BY_CODE]: 'Ordenar por código',
    [CHANGE_QUESTION_BELOW]: 'Cambiar las preguntas a continuación',

    [COPY_QUESTION]: 'Copiar pregunta',
    [COPY_QUESTION_IN_DIFF_GROUPS]: 'Copiar pregunta en grupos diferentes',

    [MOVE_UP]: 'Ascender',
    [MOVE_TO_START]: 'Mover al inicio',
    [MOVE_DOWN]: 'Mover hacia abajo',
    [MOVE_TO_END]: 'Muévete hasta el final',

    [ADD_UP]: 'Añadir arriba',
    [ADD_DOWN]: 'Añadir abajo',

    [COPY_GROUP]: 'Copiar grupo',

    [DELETE]: 'Borrar',

    [ENTER_QUESTION_CODE]: 'Ingrese el código de la pregunta',

    [LABEL_ADD_SUB_QUESTIONS]: 'Agregue al menos una subpregunta para continuar',
    [LABEL_ADD_ANSWER]: 'Agregue al menos una respuesta para continuar.',

    [VALIDATION_SLIDER_QUESTION]:
      'Configuración avanzada requerida para el tipo de control deslizante: Inicio/Min. Valor, Fin/Máx. Valor y precisión del control deslizante',

    [ADD_QUESTION]: 'Agregar pregunta',

    [QUESTION_TYPES.radio]: 'Respuesta única',
    [QUESTION_TYPES.message]: 'Mostrar texto',
    [QUESTION_TYPES.checkbox]: 'Opción Multiple',
    [QUESTION_TYPES.text]: 'Texto Libre',
    [QUESTION_TYPES.multiText]: 'Texto Libre Múltiple',
    [QUESTION_TYPES.number]: 'Entrada Numérica',
    [QUESTION_TYPES.multiNumber]: 'Entrada Numérica Múltiple',
    [QUESTION_TYPES.slider]: 'Slider',
    [QUESTION_TYPES.matrixRadio]: 'Matriz',
    [QUESTION_TYPES.matrixCheckbox]: 'Matriz de Opción Múltiple',
    [QUESTION_TYPES.ranking]: 'Ranking',
    [QUESTION_TYPES.mesage]: 'Mensaje de Texto',
    [QUESTION_TYPES.dragAndDrop]: 'Drag and Drop',
    [QUESTION_TYPES.formula]: 'Fórmula',

    [DELETE_MODAL_MESSAGE]: (name, questionsText) =>
      `¿Estás seguro de que quieres eliminar el grupo ${name}? ${
        questionsText ? 'Hay algunas preguntas integradas en él.' : ''
      }`,

    [MODAL_TEXT_DELETE]: code => `¿Estás seguro de que quieres eliminar ${code}?`,

    [MODAL_TEXT_DELETE_WITH_LOGIC]: code =>
      `Al eliminar esta pregunta, eliminará todas las lógicas y flujos relacionados con ella. Recomendamos revisar el cuestionario después de aplicar este cambio. ¿Estás seguro de que quieres eliminar ${code}?`,

    [MODAL_TEXT_DELETE_WITH_RELATED_LOGIC]: code =>
      `Esta pregunta se muestra en la condición de la(s) pregunta(s) ${code}. Si la elimina, <strong>esta condición se borrará</strong>. Estás seguro de que quieres continuar?`,

    [MODAL_TEXT_NOT_DELETE]: code =>
      `Si continúa con este cambio, se invalidarán una o más condiciones. Por favor marque la(s) pregunta(s) ${code}. ¿Estás seguro de que quieres continuar?`,

    [MODAL_ARE_YOU_SURE]: '¿Estás seguro de que quieres continuar?',

    [FORMULA_ADVICE]: formulaCode =>
      `Esta pregunta está siendo referenciada en una fórmula en ${formulaCode}. Cambiar este tipo de pregunta puede romper o borrar tu lógica. `,

    [ALTERNATIVES_ADVICE]: references =>
      `Si continúa con este cambio, su ${references} será borrado. `,

    [CHANGE_BELOW_MESSAGE]:
      'El código debe ser letras/números o cualquier/!número!/cualquiera.',

    [QUESTION_CODE_ERROR]:
      'El código de pregunta no puede comenzar con un número y no puede ser solo números.',

    [VALIDATION_LOGICS_AND_CONDITIONS]: `El flujo y las lógicas del cuestionario se crearon utilizando los códigos de pregunta actuales.
    Si los cambia ahora, <strong>se eliminarán todas las condiciones</strong> y tendrás que volver a agregarlas.
    Estás seguro de que quieres continuar?`,

    [VALIDATION_CHANGE_QUESTION_CODE]:
      'Si cambia el código de la pregunta, se eliminará toda la lógica que haga referencia a esa pregunta.',
  },
}
